export const COLORS = {
  foreverOak: [
    {
      name: 'Forever Oak N/A',
      src: 'Invita/Kitchens/Swatches/Finer_contours.jpg',
    },
  ],
  glod: [
    {
      name: 'Glød N/A',
      src: 'Invita/Kitchens/Swatches/finer-eg-natur.jpg',
    },
  ],
  northernShaker: [
    {
      name: 'Northern shaker N/A',
      src: 'Invita/Kitchens/Swatches/design-graa.jpg',
    },
    {
      name: 'Northern shaker N/A',
      src: 'Invita/Kitchens/Swatches/desingfarve_oliven.jpg',
    },
    {
      name: 'Northern shaker N/A',
      src: 'Invita/Kitchens/Swatches/Kalkgr%C3%A5.jpg',
    },
    {
      name: 'Northern shaker N/A',
      src: 'Invita/Kitchens/Swatches/lysegraa.jpg',
    },
    {
      name: 'Northern shaker N/A',
      src: 'Invita/Kitchens/Swatches/titan-hvid.jpg',
    },
  ],
  ikon: [
    {
      name: 'Ikon N/A',
      src: 'Invita/Kitchens/Swatches/finer-eg-mat-hvid.jpg',
    },
    {
      name: 'Ikon N/A',
      src: 'Invita/Kitchens/Swatches/finer-sortbejdset-eg.jpg',
    },
    {
      name: 'Ikon N/A',
      src: 'Invita/Kitchens/Swatches/finer-eg-natur.jpg',
    },
    {
      name: 'Ikon N/A',
      src: 'Invita/Kitchens/Swatches/finer-dark-nature.jpg',
    },
  ],
  cover: [
    {
      name: 'Cover N/A',
      src: 'Invita/Kitchens/Swatches/St%C3%B8vgr%C3%B8n.png',
    },
    {
      name: 'Cover Silkesgrå',
      src: 'Invita/Kitchens/Swatches/Silkegr%C3%A5.png',
    },
    {
      name: 'Cover Ultramarin',
      src: 'Invita/Kitchens/Swatches/Ultramarin.png',
    },
    {
      name: 'Cover Mat-sort',
      src: 'Invita/Kitchens/Swatches/mat-sort.jpg',
    },
  ],
  square: [
    {
      name: 'Square N/A',
      src: 'Invita/Kitchens/Swatches/finer-eg-mat-hvid.jpg',
    },
    {
      name: 'Square N/A',
      src: 'Invita/Kitchens/Swatches/finer-sortbejdset-eg.jpg',
    },
    {
      name: 'Square N/A',
      src: 'Invita/Kitchens/Swatches/finer-eg-natur.jpg',
    },
    {
      name: 'Square N/A',
      src: 'Invita/Kitchens/Swatches/titan-hvid.jpg',
    },
    {
      name: 'Square N/A',
      src: 'Invita/Kitchens/Swatches/lysegraa.jpg',
    },
    {
      name: 'Square N/A',
      src: 'Invita/Kitchens/Swatches/design-graa.jpg',
    },
    {
      name: 'Square N/A',
      src: 'Invita/Kitchens/Swatches/design-sandgraa.jpg',
    },
    {
      name: 'Square N/A',
      src: 'Invita/Kitchens/Swatches/lavagraa.jpg',
    },
    {
      name: 'Square N/A',
      src: 'Invita/Kitchens/Swatches/desingfarve_oliven.jpg',
    },
    {
      name: 'Square N/A',
      src: 'Invita/Kitchens/Swatches/Kalkgr%C3%A5.jpg',
    },
    {
      name: 'Square N/A',
      src: 'Invita/Kitchens/Swatches/Salvie.jpg',
    },
    {
      name: 'Square N/A',
      src: 'Invita/Kitchens/Swatches/Bark.jpg',
    },
  ],
  comet: [
    {
      name: 'Comet N/A',
      src: 'Invita/Kitchens/Swatches/titan-hvid.jpg',
    },
    {
      name: 'Comet N/A',
      src: 'Invita/Kitchens/Swatches/lysegraa.jpg',
    },
    {
      name: 'Comet N/A',
      src: 'Invita/Kitchens/Swatches/mat-sort.jpg',
    },
    {
      name: 'Comet N/A',
      src: 'Invita/Kitchens/Swatches/lavagraa.jpg',
    },
  ],
  nordic: [
    {
      name: 'Nordic N/A',
      src: 'Invita/Kitchens/Swatches/titan-hvid.jpg',
    },
    {
      name: 'Nordic N/A',
      src: 'Invita/Kitchens/Swatches/lysegraa.jpg',
    },
    {
      name: 'Nordic N/A',
      src: 'Invita/Kitchens/Swatches/design-sandgraa.jpg',
    },
    {
      name: 'Nordic N/A',
      src: 'Invita/Kitchens/Swatches/lavagraa.jpg',
    },
    {
      name: 'Nordic N/A',
      src: 'Invita/Kitchens/Swatches/design-graa.jpg',
    },
    {
      name: 'Nordic N/A',
      src: 'Invita/Kitchens/Swatches/desingfarve_oliven.jpg',
    },
    {
      name: 'Nordic N/A',
      src: 'Invita/Kitchens/Swatches/Salvie.jpg',
    },
    {
      name: 'Nordic N/A',
      src: 'Invita/Kitchens/Swatches/Kalkgr%C3%A5.jpg',
    },
    {
      name: 'Nordic N/A',
      src: 'Invita/Kitchens/Swatches/Bark.jpg',
    },
  ],
  newline: [
    {
      name: 'Newline N/A',
      src: 'Invita/Kitchens/Swatches/titan-hvid.jpg',
    },
    {
      name: 'Newline N/A',
      src: 'Invita/Kitchens/Swatches/lysegraa.jpg',
    },
    {
      name: 'Newline N/A',
      src: 'Invita/Kitchens/Swatches/finer-eg-mat-hvid.jpg',
    },
    {
      name: 'Newline N/A',
      src: 'Invita/Kitchens/Swatches/finer-sortbejdset-eg.jpg',
    },
    {
      name: 'Newline N/A',
      src: 'Invita/Kitchens/Swatches/finer-eg-natur.jpg',
    },
    {
      name: 'Newline N/A',
      src: 'Invita/Kitchens/Swatches/finer-dark-nature.jpg',
    },
    {
      name: 'Newline N/A',
      src: 'Invita/Kitchens/Swatches/design-sandgraa.jpg',
    },
    {
      name: 'Newline N/A',
      src: 'Invita/Kitchens/Swatches/lavagraa.jpg',
    },
    {
      name: 'Newline N/A',
      src: 'Invita/Kitchens/Swatches/design-graa.jpg',
    },
    {
      name: 'Newline N/A',
      src: 'Invita/Kitchens/Swatches/desingfarve_oliven.jpg',
    },
    {
      name: 'Newline N/A',
      src: 'Invita/Kitchens/Swatches/Salvie.jpg',
    },
    {
      name: 'Newline N/A',
      src: 'Invita/Kitchens/Swatches/Kalkgr%C3%A5.jpg',
    },
    {
      name: 'Newline N/A',
      src: 'Invita/Kitchens/Swatches/Bark.jpg',
    },
    {
      name: 'Newline N/A',
      src: 'Invita/Kitchens/Swatches/hojglans-titanhvid.jpg',
    },
  ],
  everline: [
    {
      name: 'Everline N/A',
      src: 'Invita/Kitchens/Swatches/titan-hvid.jpg',
    },
    {
      name: 'Everline N/A',
      src: 'Invita/Kitchens/Swatches/lysegraa.jpg',
    },
    {
      name: 'Everline N/A',
      src: 'Invita/Kitchens/Swatches/finer-eg-mat-hvid.jpg',
    },
    {
      name: 'Everline N/A',
      src: 'Invita/Kitchens/Swatches/finer-sortbejdset-eg.jpg',
    },
    {
      name: 'Everline N/A',
      src: 'Invita/Kitchens/Swatches/finer-eg-natur.jpg',
    },
    {
      name: 'Everline N/A',
      src: 'Invita/Kitchens/Swatches/finer-dark-nature.jpg',
    },
    {
      name: 'Everline N/A',
      src: 'Invita/Kitchens/Swatches/design-sandgraa.jpg',
    },
    {
      name: 'Everline N/A',
      src: 'Invita/Kitchens/Swatches/lavagraa.jpg',
    },
    {
      name: 'Everline N/A',
      src: 'Invita/Kitchens/Swatches/design-graa.jpg',
    },
    {
      name: 'Everline N/A',
      src: 'Invita/Kitchens/Swatches/desingfarve_oliven.jpg',
    },
    {
      name: 'Everline N/A',
      src: 'Invita/Kitchens/Swatches/Salvie.jpg',
    },
    {
      name: 'Everline N/A',
      src: 'Invita/Kitchens/Swatches/Kalkgr%C3%A5.jpg',
    },
    {
      name: 'Everline N/A',
      src: 'Invita/Kitchens/Swatches/Bark.jpg',
    },
    {
      name: 'Everline N/A',
      src: 'Invita/Kitchens/Swatches/hojglans-titanhvid.jpg',
    },
  ],
  athena: [
    {
      name: 'Athena N/A',
      src: 'Invita/Kitchens/Swatches/titan-hvid.jpg',
    },
    {
      name: 'Athena N/A',
      src: 'Invita/Kitchens/Swatches/lysegraa.jpg',
    },
    {
      name: 'Athena N/A',
      src: 'Invita/Kitchens/Swatches/finer-eg-mat-hvid.jpg',
    },
    {
      name: 'Athena N/A',
      src: 'Invita/Kitchens/Swatches/finer-sortbejdset-eg.jpg',
    },
    {
      name: 'Athena N/A',
      src: 'Invita/Kitchens/Swatches/finer-eg-natur.jpg',
    },
    {
      name: 'Athena N/A',
      src: 'Invita/Kitchens/Swatches/finer-dark-nature.jpg',
    },
    {
      name: 'Athena N/A',
      src: 'Invita/Kitchens/Swatches/design-sandgraa.jpg',
    },
    {
      name: 'Athena N/A',
      src: 'Invita/Kitchens/Swatches/lavagraa.jpg',
    },
    {
      name: 'Athena N/A',
      src: 'Invita/Kitchens/Swatches/design-graa.jpg',
    },
    {
      name: 'Athena N/A',
      src: 'Invita/Kitchens/Swatches/desingfarve_oliven.jpg',
    },
    {
      name: 'Athena N/A',
      src: 'Invita/Kitchens/Swatches/Salvie.jpg',
    },
    {
      name: 'Athena N/A',
      src: 'Invita/Kitchens/Swatches/Kalkgr%C3%A5.jpg',
    },
    {
      name: 'Athena N/A',
      src: 'Invita/Kitchens/Swatches/Bark.jpg',
    },
    {
      name: 'Athena N/A',
      src: 'Invita/Kitchens/Swatches/hojglans-titanhvid.jpg',
    },
  ],
  highline: [
    {
      name: 'Highline N/A',
      src: 'Invita/Kitchens/Swatches/titan-hvid.jpg',
    },
    {
      name: 'Highline N/A',
      src: 'Invita/Kitchens/Swatches/design-graa.jpg',
    },
    {
      name: 'Highline N/A',
      src: 'Invita/Kitchens/Swatches/design-sandgraa.jpg',
    },
    {
      name: 'Highline N/A',
      src: 'Invita/Kitchens/Swatches/lavagraa.jpg',
    },
    {
      name: 'Highline N/A',
      src: 'Invita/Kitchens/Swatches/desingfarve_oliven.jpg',
    },
    {
      name: 'Highline N/A',
      src: 'Invita/Kitchens/Swatches/Salvie.jpg',
    },
    {
      name: 'Highline N/A',
      src: 'Invita/Kitchens/Swatches/Kalkgr%C3%A5.jpg',
    },
    {
      name: 'Highline N/A',
      src: 'Invita/Kitchens/Swatches/Bark.jpg',
    },
    {
      name: 'Highline N/A',
      src: 'Invita/Kitchens/Swatches/hojglans-titanhvid.jpg',
    },
    {
      name: 'Highline N/A',
      src: 'Invita/Kitchens/Swatches/mat-sort.jpg',
    },
    {
      name: 'Highline N/A',
      src: 'Invita/Kitchens/Swatches/finer-eg-mat-hvid.jpg',
    },
    {
      name: 'Highline N/A',
      src: 'Invita/Kitchens/Swatches/finer-sortbejdset-eg.jpg',
    },
    {
      name: 'Highline N/A',
      src: 'Invita/Kitchens/Swatches/finer-eg-natur.jpg',
    },
    {
      name: 'Highline N/A',
      src: 'Invita/Kitchens/Swatches/finer-dark-nature.jpg',
    },
    {
      name: 'Highline N/A',
      src: 'Invita/Kitchens/Swatches/Finer_contours.jpg',
    },
  ],
  darkNature: [
    {
      name: 'Dark nature N/A',
      src: 'Invita/Kitchens/Swatches/finer-dark-nature.jpg',
    },
  ],
  urban: [
    {
      name: 'Urban N/A',
      src: 'Invita/Kitchens/Swatches/lysegraa.jpg',
    },
    {
      name: 'Urban N/A',
      src: 'Invita/Kitchens/Swatches/finer-eg-mat-hvid.jpg',
    },
    {
      name: 'Urban N/A',
      src: 'Invita/Kitchens/Swatches/finer-eg-natur.jpg',
    },
    {
      name: 'Urban N/A',
      src: 'Invita/Kitchens/Swatches/design-sandgraa.jpg',
    },
    {
      name: 'Urban N/A',
      src: 'Invita/Kitchens/Swatches/lavagraa.jpg',
    },
    {
      name: 'Urban N/A',
      src: 'Invita/Kitchens/Swatches/finer-sortbejdset-eg.jpg',
    },
    {
      name: 'Urban N/A',
      src: 'Invita/Kitchens/Swatches/design-graa.jpg',
    },
    {
      name: 'Urban N/A',
      src: 'Invita/Kitchens/Swatches/desingfarve_oliven.jpg',
    },
    {
      name: 'Urban N/A',
      src: 'Invita/Kitchens/Swatches/Salvie.jpg',
    },
    {
      name: 'Urban N/A',
      src: 'Invita/Kitchens/Swatches/Kalkgr%C3%A5.jpg',
    },
    {
      name: 'Urban N/A',
      src: 'Invita/Kitchens/Swatches/Bark.jpg',
    },
  ],
}

export const RANGES = {
  foreverOak: 'Invita/Kitchens/Forever%20Oak/Forever_oak2.jpg',
  glod: 'Invita/Kitchens/Gl%C3%B8d/Gloed_1.jpg',
  northernShaker: 'Invita/Kitchens/Northern%20Shaker/Northern_shaker_4.jpg',
  ikon: 'Invita/Kitchens/Ikon/Invita-03_0334.jpg',
  cover: 'Invita/Kitchens/Cover/cover_1.jpg',
  square: 'Invita/Kitchens/Square/10175_Invita_Square_sort-eg_Cam02.jpg',
  comet: 'Invita/Kitchens/Comet/Comet_Everline_Main.jpg',
  nordic: 'Invita/Kitchens/Nordic/Invita_04_0469_S2005-Y20R.jpg',
  newline: 'Invita/Kitchens/Newline/Newline_2.jpg',
  everline: 'Invita/Kitchens/Everline/Everline_2.jpg',
  athena: 'Invita/Kitchens/Athena/athena_sand.jpg',
  highline:
    'Invita/Kitchens/Highline/Athena_Highline_Sort_eg_Comet_Mat_sort_1.jpg',
  darkNature: 'Invita/Kitchens/Dark%20nature/Dark_nature_1.jpg',
  urban: 'Invita/Kitchens/Urban/urban_2.jpg',
}

export const UNITS = {
  small: 'Marbodal/Price%20Configurator/Units/units-small.png',
  medium: 'Marbodal/Price%20Configurator/Units/units-medium.png',
  large: 'Marbodal/Price%20Configurator/Units/units-large.png',
}

export const WORKTOPS = {
  granite: 'Invita/granit_bordplade.jpg',
  wood: 'Marbodal/Price%20Configurator/Worktops/ek.jpg',
  laminate: 'Marbodal/Price%20Configurator/Worktops/laminat.jpg',
  marble: 'Marbodal/B%C3%A4nkskivor/Marbodal_laminat_Modella_marmor_643_2.jpg',
}
